import React from "react";
import { ClockLoader } from "react-spinners";

const Spinner = () => {
    return (
        <div className="flex justify-center items-center">
            <ClockLoader color="D03800" />
        </div>
    );
};

export default Spinner;
